import HttpService from './HttpService';
const API_ENDPOINT = '/designation'

const DesignationService = {
  async getDesignations() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getDesignationsPaginated(pageConfig) {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`${API_ENDPOINT}-paginated?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
async addDesignation(data) {
    try {
       const response = await HttpService.post(API_ENDPOINT, data);
       return response.data;
    } catch (error) {
        throw error;
    }
},
  async updateDesignation(designationId, data) {
  try {
      const response = await HttpService.put(`${API_ENDPOINT}/${designationId}`, data);
      return response.data;
  } catch (error) {
      throw error;
  }
  },
  async deleteDesignation(designationId) {
  try {
      const response = await HttpService.delete(`${API_ENDPOINT}/${designationId}`);
      return response.data;
  } catch (error) {
      throw error;
  }
 }
};

export default DesignationService;